/** Шрифт и цвет подсветки для превью: те же правила, что у рендера. */
import { HIGHLIGHT_COLOR_INFO, SUBTITLE_FONT_INFO } from '@reels/shared/constants';
import type { HighlightColor, ProjectSettings } from '@reels/shared';

/** Семейство для превью совпадает с выбранным шрифтом рендера. */
export function previewFontFamily(font: ProjectSettings['font']): string {
  return SUBTITLE_FONT_INFO[font].family;
}

export function highlightHex(color: HighlightColor): string {
  return HIGHLIGHT_COLOR_INFO[color].hex;
}
